import { useEffect, useState } from 'react';
import { Alert, Fade } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { endNotification, notificationSelector } from './feedbackSlice';

const useStyles = createUseStyles({
  notif: {
    position: 'sticky',
    top: 0,
    left: 0,
    width: '100%',
    opacity: 0.95,
    textAlign: 'center',
    zIndex: 1000,
    cursor: 'pointer',
    height: 50,
    marginBottom: -50,
  },
  alertContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  notShown: {
    display: 'none',
  },
});

const icons = {
  success: 'fa-check-circle-o',
  info: 'fa-info-circle',
  danger: 'fa-times',
  warning: 'fa-exclamation-triangle',
};
const Notification = (props) => {
  const { variant, msg, timeout = 1500 } = useSelector(notificationSelector);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [show, setShow] = useState(false);

  let timeoutId = null;

  useEffect(() => {
    if (variant) {
      setShow(true);
    }
  }, [variant]);

  const handleCierre = () => {
    timeoutId && clearTimeout(timeoutId);
    setShow(false);
  };
  const timedCierre = () => {
    timeoutId = setTimeout(() => {
      handleCierre();
    }, timeout);
  };
  return (
    <Fade
      className={variant == null ? classes.notShown : ''}
      in={show}
      onEntering={timedCierre}
      onExited={() => dispatch(endNotification())}
      onClick={handleCierre}>
      <div className={classes.notif}>
        <Alert variant={variant} style={{ marginBottom: 0 }}>
          <i className={`fa fa-fw ${icons[variant]}`} style={{ fontSize: 20 }}></i>
          <span>{msg}</span>
        </Alert>
      </div>
    </Fade>
  );
};

export default Notification;
